import { getJson } from '../http';

// Recruiter/Edit, Contacts tab: one contact is the recruiter's admin. Rows set
// their `id` and report themselves as admin on init; "Set Admin" moves it.
export const contactAdmins = () => ({
  adminId: null,
  busy: false,

  typeFor(row) {
    if (this.adminId === row.id) return 'Admin';
    return row.type === 'Admin' ? 'User' : row.type;
  },

  async setAdmin(id, recruiterId) {
    this.busy = true;

    try {
      const data = await getJson('/RecruiterContact/SetAdmin', { id, recruiterId });

      if (data && (data.success === true || data.success === 'true')) {
        this.adminId = String(data.id ?? id);
      } else {
        window.showErrorMessage('Something went wrong, please try again later.');
      }
    } catch (error) {
      console.error(error);
      window.showErrorMessage('Something went wrong, please try again later.');
    } finally {
      this.busy = false;
    }
  },
});
